import React, { useState, useEffect, useContext } from "react";
import { Input, Button, Menu, Drawer } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import BASE_URL from "../../config";
import bioAlignImage from "../../assets/images/bio_align.png";
import menuItems from "./menuData";
import { Link, useNavigate } from "react-router-dom";
import SearchProvider from "../../Provider/SearchProvider";
const { Search } = Input;
const Header = () => {
  const { searchTable, setSearchTable } = useContext(SearchProvider);
  const navigate = useNavigate();
  const [isSticky, setIsSticky] = useState(false);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState(searchTable.search);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsSticky(true); // If scrolled more than 50px, make header sticky
    } else {
      setIsSticky(false);
    }
  };
  const onChange = (value) => {
    setSearch(value);
  };
  // console.log(searchTable);
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  return (
    <header
      className={`transition-all duration-300 ${
        isSticky ? "fixed top-0 left-0 w-full z-10 bg-white shadow-md" : ""
      }`}
      style={{
        paddingTop: isSticky ? "10px" : "20px",
        paddingBottom: isSticky ? "10px" : "20px",
        position: isSticky ? "fixed" : "relative",
      }}
    >
      <div className="container ">
        <div className="hidden lg:block">
          <nav className="flex justify-between items-center gap-10">
            <Link to={`${BASE_URL}`}>
              <img
                src={bioAlignImage}
                alt="bio_align"
                className="w-[20rem] h-auto"
              />
            </Link>
            <div style={{ width: "80%" }} className="flex items-center  gap-5">
              <h3 className="font-primary font-medium text-xl text-nowrap items-center ">
                Find a Clinic
              </h3>
              <div className="search-container">
                <input
                  className="search-input"
                  type="text"
                  placeholder="Search City / Province"
                  onChange={(e) => onChange(e.target.value)}
                />
                <button
                  className="go-button"
                  onClick={() => navigate(`/search?search=${search}`)}
                >
                  Go
                </button>
              </div>

              {/* <Search
                value={searchTable?.search}
                placeholder="Search"
                onChange={(e) => onChange(e.target.value)}
                enterButton={
                  <Button
                    style={{
                      background: "#268F81",
                      height: "40px",
                      borderRadius: "0px 5px 5px 0px",
                      padding: "0px 10px",
                      fontSize: "14px",
                      color: "#fff",

                    }}
                    onClick={() =>
                      navigate(`/search?search=${searchTable?.search}`)
                    }
                  >
                    Go
                  </Button>
                }
                size="large"
                style={{
                  width: 250,
                  height: 40,
                  borderRadius: 10,
                  border: "1px solid #E7E7E7",
                }}
              /> */}
            </div>
            <div style={{ width: "80%" }} className="flex gap-10 justify-end">
              {menuItems.map((item) => (
                <Link to={item.path} key={item.key}>
                  <div className="cursor-pointer font-primary font-normal text-2xl">
                    {item.label}
                  </div>
                </Link>
              ))}
            </div>
          </nav>
        </div>
        <div className="block lg:hidden">
          <div className="flex justify-between items-center">
            <Link to={`${BASE_URL}`}>
              <img
                src={bioAlignImage}
                alt="bio_align"
                className="w-[100px] h-auto"
              />
            </Link>
            <div>
              {/* <Button type="primary" onClick={() => showDrawer()}>
            {open ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </Button> */}
              <div
                className="bg-primary  w-[40px] h-[40px] flex justify-center items-center "
                onClick={() => showDrawer()}
              >
                {open ? (
                  <MenuUnfoldOutlined className="text-white text-[18px]" />
                ) : (
                  <MenuFoldOutlined className="text-white text-[18px]" />
                )}
              </div>
              <Drawer title="Menu" onClose={onClose} open={open}>
                <Menu
                  theme="light"
                  defaultSelectedKeys={["1"]}
                  mode="inline"
                  onClick={onClose}
                  items={menuItems.map((item) => ({
                    key: item.key,
                    label: <Link to={item.path}>{item.label}</Link>,
                  }))}
                />
              </Drawer>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
